import { useState, useEffect } from "react";

import { getUser } from "./ChatService";
import UserLayout from "./UserLayout";

export default function Contact({ chatRoom, currentUser }) {
  return <UserLayout user={chatRoom} currentUser={currentUser} />;
}